import React from 'react';
import { cn } from './cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}
export function Card({
  className,
  interactive,
  children,
  ...rest
}: CardProps) {
  return <div className={cn('rounded-2xl border border-white/[0.06] bg-ink-850 shadow-card', interactive && 'transition-colors duration-200 hover:border-white/[0.14] hover:bg-ink-800', className)} {...rest} data-id="element-675" data-mp="8ax08skdrvzc">
      {children}
    </div>;
}